<form
	class="sdp-saml-wizard-form"
	[formGroup]="form"
	novalidate
>
	<div class="sdp-clear"></div>
	<div class="sdp-form-control sdp-saml-wizard-selectIdp-select">
		<mat-form-field>
			<mat-select
				[disabled]="!isDataLoaded"
				placeholder="{{ 'saml.wizard.selectIdp.select.placeholder' | translate }}"
				formControlName="idpName"
				(selectionChange)="onChange($event)"
			>
				<mat-option
					*ngFor="let provider of providerData"
					[value]="provider"
				>{{ provider }}</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
</form>